// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"06b2375c","781":"85be118b","797":"73f3ec90","813":"78502116"}[chunkId] + ".chunk.js";
};